import gql from 'graphql-tag'
import {
	addClientMain,
	addClientFields
} from './fragments'

export default gql`
mutation CA_Mutation_createCreditClient($required: CreditClientReqFields!, $fields: CreditClientFields) {
  cashAssist {
	  createMutation: createCreditClient(required: $required, fields: $fields) {
		  	id
			...addClientMain
			...addClientFields
		}
  }
}
${addClientMain}
${addClientFields}`
